import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Button } from 'reactstrap';
import AssistanceModal from '../../components/AssistanceModal';


const AuthWrapperFooter = ({ displayAssistance, toggleDisplayAssistance }) => {
    const [localDisplayAssistance, setLocalDisplayAssistance] = useState(false);

    const localToggleDisplayAssistance = (e) => {
        if (e) e.preventDefault();
        setLocalDisplayAssistance(!localDisplayAssistance);
    };

    const modalOpen = displayAssistance !== undefined ? displayAssistance : localDisplayAssistance;
    const modalToggle = toggleDisplayAssistance || localToggleDisplayAssistance;

    return (
        <>
            <div>
                <Button
                    id="contact-modal-trigger"
                    onClick={modalToggle}
                    color="link"
                >
                    Contact Us
                </Button>
                <div>
                    Copyright &copy; {Moment().year()} HealthStream, Inc.{' '}
                    <span>All Rights Reserved.</span>
                </div>

            </div>
            <AssistanceModal
                displayAssistance={modalOpen}
                toggleDisplayAssistance={modalToggle}
            />
        </>
    );
};

AuthWrapperFooter.propTypes = {
    displayAssistance: PropTypes.bool,
    toggleDisplayAssistance: PropTypes.func,
};

AuthWrapperFooter.defaultProps = {
    displayAssistance: undefined,
    toggleDisplayAssistance: undefined,
};

export default AuthWrapperFooter;
